import debounce from 'lodash/debounce';

import SearchFieldListItem from './SearchFieldListItem.vue';
import SearchFieldSelectedItem from './SearchFieldSelectedItem.vue';
import WidgetFieldMixin from '../WidgetFieldMixin';
import Loader from '@/components/common/Loader';

export default {
	name: 'SearchFieldMixin',
	components: {
		Loader,
		SearchFieldListItem,
		SearchFieldSelectedItem,
	},
	mixins: [WidgetFieldMixin],
	methods: {
		loadMore() {
			this.seeMore();
		},
		searchField() {}, // just a placeholder, definition on created
		searchFieldOnDemand() {}, // just a placeholder, definition on created
		endIntersect(entries, observer, isIntersecting) {
			if (isIntersecting) {
				this.seeMore();
			}
		},
		seeMore() {
			this.page++;
			this.searchField();
		},
		resetState() {
			this.page = 1;
		},
		localLoadMenuItems() {
			this.loadMenuItems();
		},
	},
	created() {
		this.searchField = debounce(this.localLoadMenuItems.bind(this), 250);
		this.searchFieldOnDemand = this.localLoadMenuItems.bind(this);
	},
	watch: {
		search: {
			handler: debounce(function () {
				if (!this.isSearchable && this.page !== 1) {
					return;
				}

				// prevent getting data from server when search-input changed because the user chose an item, or request was sent and search is emptied
				if (this.preventNextSearchCall) {
					this.preventNextSearchCall = false;
					return;
				}

				// prefill search term
				if (this.prefillValue && !this.search && this.needToChangeSearch) {
					this.search = this.prefillValue;
				}
				//allow clearing the search term and searching whatever the user wants
				if (this.search && this.search !== this.prefillValue) {
					this.needToChangeSearch = false;
				}

				if ((this.isSearchable && !!this.search) || this.page === 1) {
					this.resetState();
					this.searchField();
				}
			}, 250),
		},
	},
};
